/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteTenantConfig$Params {
  id: string;
  key: 'MAX_CONFIGURED_USERS' | 'MAX_CONCURRENT_SESSIONS' | 'USER_REACTIVATION_GRACE_HOURS' | 'SHOULD_SEND_NOTIFICATION' | 'SHOULD_SEND_REMINDER';
}

export function deleteTenantConfig(http: HttpClient, rootUrl: string, params: DeleteTenantConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteTenantConfig.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('key', params.key, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteTenantConfig.PATH = '/api/tenants/{id}/configs/{key}';
